import axios from "axios";
import { TrackEventRequest, platformApiApi } from "@capone/platform-api";
import { getGlobalTrackingProperties } from "../utils/getGlobalTrackingProperties";
import { getConfigTenant } from "../utils/getTenant";

export const trackEvent = (req: TrackEventRequest): Promise<boolean> =>
  new Promise(async (resolve, reject) => {
    try {
      req.properties = {
        ...req.properties,
        ...getGlobalTrackingProperties(getConfigTenant(), {}),
      };
      const res = await platformApiApi(axios).apiV0TrackingEventPost(req);
      resolve(res.data.Response === "Success");
    } catch (e) {
      console.error("Error tracking event:", e);
      reject(e);
    }
  });
